// Phase 12.2 — poll /health/ingestion every 30s so the dashboard
// banner and the ops debug panel reflect ground truth without each
// component running its own fetch.

import { useQuery } from '@tanstack/react-query';
import { opsApi } from '@/integrations/api/client';
import type { IngestionHealth } from '@/types/ingestion';

export function useIngestionHealth() {
  return useQuery<IngestionHealth>({
    queryKey: ['health', 'ingestion'],
    queryFn: () => opsApi.ingestion() as Promise<IngestionHealth>,
    refetchInterval: 30_000,
    staleTime: 15_000,
    refetchOnWindowFocus: true,
  });
}
